import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { CheckCircle, Clock, Share2, Users } from 'lucide-react';
import Sidebar from '../../components/Sidebar';
import Navbar from '../../components/Navbar';
import CandidatesTab from './AllApplicants';
import ReferralsTab from './ReferralsList';
import { OfferJoiningTab } from './OfferJoiningPage';
import { TimelineHistoryDashboardTab } from './TimelineHistoryPage';
import { usePageVisibility } from '../../contexts/PageVisibilityContext';
const TABS = [
    { id: 'candidates', label: 'Candidates', icon: Users, pageKey: 'recruitment.candidates' },
    { id: 'referrals', label: 'Referrals', icon: Share2, pageKey: 'recruitment.referrals' },
    { id: 'offerJoining', label: 'Offer & Joining', icon: CheckCircle, pageKey: 'recruitment.offerJoining' },
    { id: 'timelineHistory', label: 'Timeline & History', icon: Clock, pageKey: 'recruitment.timelineHistory' },
];
// Reached from two sidebar links ("Candidate Management" → /applicants,
// "Referrals" → /referrals) plus an optional ?tab= override, so the
// starting tab is derived from whichever of those got the user here.
function getInitialTab(pathname, tabParam) {
    if (tabParam === 'referrals' || tabParam === 'offerJoining' || tabParam === 'timelineHistory')
        return tabParam;
    if (pathname.startsWith('/referrals'))
        return 'referrals';
    if (pathname.startsWith('/offer-joining'))
        return 'offerJoining';
    if (pathname.startsWith('/timeline-history'))
        return 'timelineHistory';
    return 'candidates';
}
const CandidatesReferrals = () => {
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    const { canViewKey } = usePageVisibility();
    const visibleTabs = useMemo(() => TABS.filter((tab) => canViewKey(tab.pageKey)), [canViewKey]);
    const [activeTab, setActiveTab] = useState(() => getInitialTab(location.pathname, searchParams.get('tab')));
    useEffect(() => {
        setActiveTab(getInitialTab(location.pathname, searchParams.get('tab')));
    }, [location.pathname, searchParams]);
    useEffect(() => {
        if (visibleTabs.length && !visibleTabs.some((tab) => tab.id === activeTab)) {
            setActiveTab(visibleTabs[0].id);
        }
    }, [activeTab, visibleTabs]);
    const handleTabChange = (tab) => {
        setActiveTab(tab);
        setSearchParams(tab === 'candidates' ? {} : { tab });
    };
    return (_jsxs("div", { className: "flex h-screen overflow-hidden", style: { background: '#F3F5EF' }, children: [_jsx("div", { className: "w-64 flex-shrink-0 z-10 bg-white border-r", children: _jsx(Sidebar, {}) }), _jsxs("div", { className: "flex-1 flex flex-col min-w-0", children: [_jsx("div", { className: "h-16 bg-white shadow-sm z-20 flex items-center px-4", children: _jsx(Navbar, {}) }), _jsx("div", { className: "bg-white border-b px-6", children: _jsx("div", { className: "flex gap-1", children: visibleTabs.map(({ id, label, icon: Icon }) => (_jsxs("button", { onClick: () => handleTabChange(id), className: `flex items-center gap-1.5 px-4 py-3 text-sm font-semibold border-b-2 transition -mb-px ${activeTab === id
                                    ? 'border-[#eef3e6]0 text-[#3d5420]'
                                    : 'border-transparent text-gray-400 hover:text-gray-600'}`, children: [_jsx(Icon, { size: 15 }), label] }, id))) }) }), _jsxs("main", { className: "flex-1 overflow-auto p-6", children: [activeTab === 'candidates' && _jsx(CandidatesTab, {}), activeTab === 'referrals' && _jsx(ReferralsTab, {}), activeTab === 'offerJoining' && _jsx(OfferJoiningTab, {}), activeTab === 'timelineHistory' && _jsx(TimelineHistoryDashboardTab, {})] })] })] }));
};
export default CandidatesReferrals;
